'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tborder: 1px solid ', ';\n    border-radius: 4px;\n'], ['\n\tborder: 1px solid ', ';\n    border-radius: 4px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    height: 8px;\n'], ['\n    height: 8px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UsageComponent = (0, _styledComponents2.default)(_metrixCommon.Container)(_templateObject, function (_ref) {
    var error = _ref.error;
    return error ? _metrixCommon.Colors.Error : _metrixCommon.Colors.StrokeLight;
});

var Spacer = _styledComponents2.default.div(_templateObject2);

var WorkflowUsage = function (_React$Component) {
    _inherits(WorkflowUsage, _React$Component);

    function WorkflowUsage(props) {
        _classCallCheck(this, WorkflowUsage);

        var _this = _possibleConstructorReturn(this, (WorkflowUsage.__proto__ || Object.getPrototypeOf(WorkflowUsage)).call(this, props));

        _this.getEquipmentUsage = function (operators) {
            var equipmentUsage = 0;
            if (operators && operators.length > 0) {
                operators.map(function (operator) {
                    var operatorUsage = (0, _metrixCommon.getElementValueByCode)(operator.elements, 'Value');
                    if (operatorUsage) {
                        equipmentUsage += parseInt(operatorUsage);
                    }
                });
            }
            return equipmentUsage;
        };

        _this.getIcon = function (icon) {
            switch (icon) {
                case 'profile':
                    return _react2.default.createElement(_metrixCommon.PersonIcon, { size: _metrixCommon.Sizes.xl, primary: _metrixCommon.Colors.Secondary });
                case 'vehicle':
                default:
                    return _react2.default.createElement(_metrixCommon.VehicleIcon, { size: _metrixCommon.Sizes.xl, primary: _metrixCommon.Colors.Secondary });
            }
        };

        _this.state = {
            interacted: false,
            left: false
        };
        return _this;
    }

    _createClass(WorkflowUsage, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var operatorElementIndex = this.props.equipment.elements.findIndex(function (x) {
                return x.code === 'Operators';
            });
            var operators = (0, _metrixCommon.getElementsByCode)(this.props.equipment.elements, 'Operators');
            var total = this.getEquipmentUsage(operators);
            var error = this.state.interacted && this.state.left && total !== this.props.limit;
            var success = total === this.props.limit;

            return _react2.default.createElement(
                UsageComponent,
                { bottom: _metrixCommon.Sizes.xs,
                    error: error,
                    mouseEnterEvent: function mouseEnterEvent() {
                        return _this2.setState({ left: false });
                    },
                    mouseLeaveEvent: function mouseLeaveEvent() {
                        return _this2.setState({ left: true });
                    },
                    touchStartEvent: function touchStartEvent() {
                        return _this2.setState({ left: false });
                    },
                    touchEndEvent: function touchEndEvent() {
                        return _this2.setState({ left: true });
                    }
                },
                _react2.default.createElement(
                    _metrixCommon.Container,
                    { horizontalAlignment: _metrixCommon.Alignments.center, top: _metrixCommon.Sizes.sm, bottom: _metrixCommon.Sizes.xs },
                    this.getIcon((0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Icon'))
                ),
                _react2.default.createElement(_metrixCommon.Header, { size: _metrixCommon.Sizes.sm, text: (0, _metrixCommon.getElementValueByCode)(this.props.equipment.elements, 'Label') }),
                operators && operators.map(function (operator, operatorIndex) {
                    var valueElementIndex = operator.elements.findIndex(function (x) {
                        return x.code === 'Value';
                    });
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(Spacer, null),
                        _react2.default.createElement(
                            _metrixCommon.Grid,
                            null,
                            _react2.default.createElement(
                                _metrixCommon.Row,
                                { nogutter: true },
                                _react2.default.createElement(
                                    _metrixCommon.Column,
                                    { xs: 8 },
                                    _react2.default.createElement(_metrixCommon.Label, { textAlign: _metrixCommon.Alignments.left,
                                        text: (0, _metrixCommon.getElementValueByCode)(operator.elements, 'Label') })
                                ),
                                _react2.default.createElement(
                                    _metrixCommon.Column,
                                    { xs: 4 },
                                    _react2.default.createElement(_metrixCommon.Label, { textAlign: _metrixCommon.Alignments.right,
                                        text: parseInt((0, _metrixCommon.getElementValueByCode)(operator.elements, 'Value')) + '%' })
                                )
                            ),
                            _react2.default.createElement(
                                _metrixCommon.Row,
                                { nogutter: true },
                                _react2.default.createElement(
                                    _metrixCommon.Column,
                                    { md: 24 },
                                    _react2.default.createElement(_metrixCommon.Slider, {
                                        options: _this2.props.options,
                                        type: 'ratio',
                                        header: false,
                                        value: '' + parseInt((0, _metrixCommon.getElementValueByCode)(operator.elements, 'Value')),
                                        changeEvent: function changeEvent(value) {
                                            _this2.props.doSetReturn({
                                                componentCode: _this2.props.component.code,
                                                code: 'elements.' + _this2.props.equipmentIndex + '.elements.' + operatorElementIndex + '.elements.' + operatorIndex + '.elements.' + valueElementIndex + '.value',
                                                value: value
                                            });
                                            _this2.setState({ interacted: true });
                                        },
                                        error: error,
                                        narrow: true
                                    })
                                )
                            )
                        )
                    );
                }),
                _react2.default.createElement(
                    _metrixCommon.Grid,
                    null,
                    _react2.default.createElement(
                        _metrixCommon.Row,
                        null,
                        _react2.default.createElement(
                            _metrixCommon.Column,
                            null,
                            _react2.default.createElement(_metrixCommon.Label, { error: error, success: success, text: error ? 'Total of usages must be ' + this.props.limit + '%' : success ? 'Great! Total usage is ' + total + '%' : 'Total usage is ' + total + '%' })
                        )
                    )
                )
            );
        }
    }]);

    return WorkflowUsage;
}(_react2.default.Component);

exports.default = WorkflowUsage;